import type { ManagementTranslations } from '../en-US/management.translations';

const managementTranslations: Partial<ManagementTranslations> = {
  title: 'BiteCritic Yönetim',
  dashboard: 'Kontrol Paneli',
  users: 'Kullanıcı Yönetimi',
  settings: 'Ayarlar',
  foods: {
    title: 'Yemek Yönetimi',
    createNew: 'Yeni Yemek Ekle',
    id: 'ID',
    name: 'İsim',
    category: 'Kategori',
    country: 'Ülke',
    status: 'Durum',
    createdAt: 'Oluşturulma Tarihi',
    actions: 'İşlemler',
    noFoodsFound: 'Yemek bulunamadı',
    searchPlaceholder: 'Yemek ara...',
    allStatuses: 'Tüm Durumlar',
    allCategories: 'Tüm Kategoriler',
    sortNewest: 'En Yeni',
    sortOldest: 'En Eski',
    sortNameAZ: 'İsim A-Z',
    sortNameZA: 'İsim Z-A',
    showing: 'Toplam {{total}} yemekten {{from}} - {{to}} arası gösteriliyor',
    confirmDelete: 'Bu yemeği silmek istediğinizden emin misiniz?',
    approve: 'Onayla',
    reject: 'Reddet',
    createFood: 'Yeni Yemek Oluştur',
    editFood: 'Yemeği Düzenle',
    viewFood: 'Yemek Detaylarını Görüntüle',
    namePlaceholder: 'Yemek adını girin',
    descriptionPlaceholder: 'Yemek açıklamasını girin',
    selectCategory: 'Bir kategori seçin',
    selectCountry: 'Bir ülke seçin',
    selectStatus: 'Bir durum seçin',
    imageUrl: 'Resim URL',
    imageUrlPlaceholder: "Resim URL'sini girin",
    imagePreview: 'Resim Önizleme',
    rowsPerPage: 'Sayfa başına {{count}}',
    translations: 'Çeviriler',
    description: 'Açıklama',
    formatJson: 'JSON Formatla',
    jsonPlaceholder: 'Yemek verilerini JSON formatında girin',
    jsonInstructions: 'JSON Format Talimatları',
    jsonInstructionName: 'İsim zorunludur ve metin olmalıdır',
    jsonInstructionCategory: 'CategoryId zorunludur ve sayı olmalıdır',
    jsonInstructionCountry: 'CountryId isteğe bağlıdır ve sayı olmalıdır',
    jsonInstructionStatus: 'Durum şunlardan biri olmalıdır',
    jsonInstructionTranslations:
      'Çeviriler, dil kodlarından çeviri nesnelerine bir kayıt olmalıdır',
    jsonUpdateError: '{{field}} güncellenirken hata: {{error}}',
    hideFilters: 'Filtreleri Gizle',
    showFilters: 'Filtreleri Göster',
    totalItems: 'Toplam {{count}} öğe',
    aiPrompt: {
      title: 'AI ile Yemek Verisi Oluştur',
      description: 'Yemek verisi oluşturmak için AI kullanın',
      inputLabel: 'Yemek Adı',
      inputPlaceholder: 'Bir yemek adı girin',
      buttonText: 'AI ile Oluştur',
      copyPrompt: 'Promptu Kopyala',
      openInChatGPT: "ChatGPT'de Aç",
      promptCopied: 'Prompt panoya kopyalandı!',
      instructions: 'Talimatlar:',
      step1: '1. Bir yemek adı girin',
      step2: '2. "AI ile Oluştur" düğmesine tıklayın veya promptu kopyalayın',
      step3:
        '3. Promptu ChatGPT\'ye yapıştırın veya "ChatGPT\'de Aç" düğmesine tıklayın',
      step4:
        '4. JSON yanıtını kopyalayın ve yeni bir yemek öğesi oluşturmak için kullanın',
    },
  },
  languages: {
    en: 'İngilizce',
    nl: 'Hollandaca',
    tr: 'Türkçe',
    de: 'Almanca',
    fr: 'Fransızca',
    es: 'İspanyolca',
    it: 'İtalyanca',
    pt: 'Portekizce',
  },
};

export default managementTranslations;
